import { UserGlobalFilter } from "../../../models/UserModel/UserGlobalFilter";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_GETALLUSERGLOBALFILTER } from "../../../utils/constants";
import ToastMessage from "../../../common/ToastMessage";
import userGlobalFilterService from "../../../services/userService/userGlobalFilterService";

interface AddGlobalFilterContext {
  previousGlobalFilters: UserGlobalFilter[];
}

const useAddUserGlobalFilter = (userId: string) => {
  const queryClient = useQueryClient();

  return useMutation<
    UserGlobalFilter,
    Error,
    UserGlobalFilter,
    AddGlobalFilterContext
  >({
    mutationFn: userGlobalFilterService.AddGlobalFilter,

    onMutate: () => {
      const previousGlobalFilters =
        queryClient.getQueryData<UserGlobalFilter[]>([
          CACHE_KEY_GETALLUSERGLOBALFILTER,
          userId,
        ]) || [];

      return { previousGlobalFilters };
    },

    onSuccess: (savedGlobalFilter) => {
      queryClient.setQueryData<UserGlobalFilter[]>(
        [CACHE_KEY_GETALLUSERGLOBALFILTER, userId],
        (globalFilters) =>
          globalFilters
            ? [savedGlobalFilter, ...globalFilters]
            : [savedGlobalFilter]
      );
      ToastMessage.Success();
    },

    onError: (error, newGlobalFilter, context) => {
      if (!context) return;

      queryClient.setQueryData<UserGlobalFilter[]>(
        [CACHE_KEY_GETALLUSERGLOBALFILTER, userId],
        context.previousGlobalFilters
      );
      ToastMessage.Failed();
    },
  });
};

export default useAddUserGlobalFilter;
